import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { GlobalCopilotDrawerProps } from './GlobalCopilotDrawer';

const loadCatalystGlobalCopilotDrawerHost = (): Promise<typeof import('./CatalystGlobalCopilotDrawerHost')> =>
  import(/* webpackChunkName: "4-feat-global-copilot-drawer" */ './CatalystGlobalCopilotDrawerHost');

const CatalystGlobalCopilotDrawerHostLoader = async () => {
  const { CatalystGlobalCopilotDrawerHost } = await loadCatalystGlobalCopilotDrawerHost();

  return { default: CatalystGlobalCopilotDrawerHost };
};

export const LoadableCatalystGlobalCopilotDrawerHost: ComponentType<GlobalCopilotDrawerProps> =
  lazyLoadOnRender<GlobalCopilotDrawerProps>({
    loader: CatalystGlobalCopilotDrawerHostLoader,
  });
